<template>
  <nav
    class="flex gap-1 border-b border-primary-400 mt-6"
    :aria-label="$t('account.sections')"
  >
    <!-- The active style is bound rather than layered on with activeClass:
         `border-transparent` and `border-highlight` would otherwise both be
         present and the winner decided by stylesheet order, not intent. -->
    <router-link
      v-for="tab in tabs"
      :key="tab.to"
      :to="tab.to"
      class="px-4 py-3 -mb-px border-b-2 text-sm uppercase tracking-widest"
      :class="tabClass(tab.to)"
    >
      {{ $t(tab.label) }}
    </router-link>
  </nav>
</template>

<script>
export default {
  name: "AccountTabs",

  data() {
    return {
      tabs: [
        { to: "/profile", label: "account.profile" },
        { to: "/settings", label: "account.settings" },
      ],
    };
  },

  methods: {
    tabClass(to) {
      return this.$route.path === to
        ? "text-highlight border-highlight"
        : "text-muted border-transparent hover:text-highlight";
    },
  },
};
</script>
